import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * DevProtectedRoute — Guards the /dev route.
 * Only allows access if the user is authenticated AND has is_developer = true.
 * Redirects to /login otherwise.
 */
const DevProtectedRoute = ({ children }) => {
    const { user, loading } = useAuth();

    if (loading) {
        return (
            <div style={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: '#0f172a'
            }}>
                <div style={{
                    width: 48,
                    height: 48,
                    border: '3px solid rgba(99, 102, 241, 0.2)',
                    borderTopColor: '#6366f1',
                    borderRadius: '50%',
                    animation: 'spin 0.8s linear infinite'
                }} />
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    if (!user.is_developer) {
        return <Navigate to="/login" replace />;
    }

    return children;
};

export default DevProtectedRoute;
